import { render, staticRenderFns } from "./Haber.vue?vue&type=template&id=51c6bc8e&scoped=true&"
import script from "./Haber.vue?vue&type=script&lang=js&"
export * from "./Haber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c6bc8e",
  null
  
)

export default component.exports